import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import { ICampaignInputOptions } from '../models/campaign-input-options.model';
import endpoints from './endpoints/index.endpoints';

const CampaignsInputOptionsApi = {
	get: (keys: CampaignInputOptionKey[]): Promise<ICampaignInputOptions> => {
		return ask.get(endpoints.campaigns.inputOptions(), new URLSearchParams(keys.map((k): [string, string] => [k, ''])));
	},
};

export type CampaignInputOptionKey =
	| 'advertisers'
	| 'strategies'
	| 'pretargetings'
	| 'keyGenerators'
	| 'bannerSizes'
	| 'webappsCidSegments'
	| 'accounts'
	| 'designs'
	| 'phases'
	| 'deals';

export const CAMPAIGN_FORM_INPUT_OPTION_KEYS: CampaignInputOptionKey[] = [
	'advertisers',
	'strategies',
	'pretargetings',
	'accounts',
	'phases',
	'keyGenerators',
];

export { CampaignsInputOptionsApi };
